<template>
  <v-app-bar app class="app-header white" height="100px">
    <div
      class="risk-sticker d-none d-sm-flex flex-wrap align-center justify-center text-5 darkgray--text text-center px-5"
    >
      Stakewithus has been acquired by Nansen. Find out what this <a class="ml-1" _target="blank" href="https://www.nansen.ai/post/staking-meets-analytics-nansen-acquires-stakewithus-and-unveils-nsn-points-program?utm_source%3Dswu-twitter%26utm_swu-twitter%3Dsocial%26utm_campaign%3Dstakewithus-ann_30_12_99">means for you!</a>
    </div>
    <v-container
      class="nav-wrap d-flex align-center justify-space-between pa-0 pa-sm-3"
    >
      <div class="d-flex align-center">
        <div class="d-flex d-md-none mr-3">
          <v-menu
            transition="slide-y-transition"
            bottom
            left
            offset-y
            content-class="elevation-1 mt-md-5 navs-menu-wrap"
            z-index="11"
            v-model="menuShowed"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="icongray--text" v-bind="attrs" v-on="on"
                >mdi-menu</v-icon
              >
            </template>
            <div class="rounded-10 navs-menu">
              <div class="rounded-10 white">
                <div class="shadow-base pa-5">
                  <div class="d-flex justify-end mb-3 pt-3">
                    <v-icon @click="menuShowed = false" class="icongray--text"
                      >mdi-close</v-icon
                    >
                  </div>
                  <menu-items />
                </div>
              </div>
            </div>
          </v-menu>
        </div>
        <router-link :to="{ name: 'Home' }" class="line-height-0">
          <img
            src="@/assets/logos/wordmark-orange.svg"
            alt="unagii"
            height="26px"
        /></router-link>
      </div>

      <div class="flex-grow-1 d-none d-md-flex justify-end">
        <menu-items />
      </div>
      <div class="d-flex align-center">
        <div class="pa-2 mx-5 d-none d-sm-flex align-self-stretch">
          <v-divider vertical></v-divider>
        </div>
        <notification-menu v-if="isAuthenticated" />
        <wallet-menu class="ml-5" />
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
import WalletMenu from "./WalletMenu";
import NotificationMenu from "./NotificationMenu";
import MenuItems from "./MenuItems";
import { mapGetters } from "vuex";

export default {
  components: {
    WalletMenu,
    NotificationMenu,
    MenuItems,
  },
  computed: mapGetters({
    isAuthenticated: "auth/isAuthenticated",
  }),
  data: () => ({
    menuShowed: false,
  }),
  watch: {
    menuShowed(value) {
      this.$nextTick(() => {
        const display = value ? "block" : "none";
        document.getElementById("menuOverlay").style.display = display;
      });
    },
  },
};
</script>

<style lang="scss">
.app-header {
  box-shadow: 0px 1px 0px var(--lightgray) !important;
  .v-toolbar__content {
    flex-direction: column;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .nav-wrap {
    height: 100px;
  }
  .risk-sticker {
    width: 100vw;
    height: 44px;
    background-color: #f660331a;
    line-height: 18px !important;
  }
}

@media (max-width: 599px) {
  .app-header {
    height: 100px !important;
    .v-toolbar__content {
      height: 100px !important;
    }
  }
  .page-content {
    padding-top: 100px !important;
  }
}
.navs-menu-wrap {
  max-width: 100% !important;
  @media (max-width: 959px) {
    width: 100vw !important;
    left: 0 !important;
    top: -12px !important;
    margin-top: 0 !important;
  }
}

.theme--dark {
  .risk-sticker {
    background-color: #222e3b !important;
  }
}
</style>
